export const retryButtonSx = {
  borderRadius: '6px',
  px: '16px',
  height: '36px',
  fontSize: 13,
  fontWeight: 600,
  minWidth: 144,
};
